export const CafeBazaarDownloadUrl = 'https://cafebazaar.ir/app/com.khanoumi.android'
export const MykeyDownloadUrl = 'https://myket.ir/app/com.khanoumi.android'
export const AppStarDownloadUrl = 'https://app-star.store/app.php?id=khanoomi'
export const SibcheDownloadUrl = 'https://sibche.com/applications/khanoumi'
export const SibAppDownloadUrl = 'https://sibapp.com/applications/Khanoomi'
export const SibIraniDownloadUrl = 'https://sibirani.com/apps/khanoumi-com'
